import React from "react";
import { PDFDownloadLink } from "@react-pdf/renderer";
import Button from "@components/buttons/Button/Button";
import MemorialDocument, { MemorialDocumentProps } from "./MemorialDocument";

const MemorialPDFDownloadButton: React.FC<MemorialDocumentProps> = ({
    memorial, businessLogo, videoPosters,
}) => {
    const fileName = `${memorial.firstName}_${memorial.lastName}_Memorial.pdf`;

    return (
        <PDFDownloadLink
            document={(
                <MemorialDocument
                    memorial={memorial}
                    businessLogo={businessLogo}
                    videoPosters={videoPosters}
                />
            )}
            fileName={fileName}
        >
            <Button variant="primary" size="medium" onClick={() => {}}>
                Download
            </Button>
        </PDFDownloadLink>
    );
};

export default MemorialPDFDownloadButton;
